//Load
// window.addEventListener("load", function () {
//   document.querySelector('body').classList.add('fully-loaded');
// });

//Child Drops
// let childDropBtns = document.querySelectorAll(".child-drop");
// childDropBtns.forEach(function (item, i) {
//   let currentBtn = item.querySelector(".mid-level");
//   currentBtn.addEventListener("click", function (event) {
//     event.preventDefault();
//     clearChildDrops();
//     this.classList.toggle("active");
//     let currentChildList = item.querySelector("ul");
//     currentChildList.classList.toggle("active");
//   });
// });

// let clearChildDrops = function () {
//   childDropBtns.forEach(function (item, i) {
//     item.querySelector("ul").classList.remove("active");
//     item.querySelector(".mid-level").classList.remove("active");
//   });
// };
let childDropBtns = document.querySelectorAll(".child-drop");

childDropBtns.forEach(function (item, i) {
  let currentBtn = item.querySelector(".mid-level");
  let currentChildList = item.querySelector("ul");

  if (!currentBtn || !currentChildList) {
    console.warn("Missing required elements for child-drop:", item);
    return;
  }

  currentBtn.addEventListener("click", function (event) {
    event.preventDefault();
    clearChildDrops(i); // Pass the current index to exclude from clearing
    this.classList.toggle("active");
    currentChildList.classList.toggle("active");
  });
});

let clearChildDrops = function (excludeIndex) {
  childDropBtns.forEach(function (item, i) {
    if (i !== excludeIndex) {
      let btn = item.querySelector(".mid-level");
      let childList = item.querySelector("ul");
      if (btn && childList) {
        btn.classList.remove("active");
        childList.classList.remove("active");
      }
    }
  });
};


//Nav Overlay
let navOverlay = document.querySelector("#nav-overlay");

let activateOverlay = function () {
  navOverlay.classList.add("active");
  //document.querySelector("body").classList.add("no-scroll");
};

const killOverlay = function () {
  // let defaultCaption = document.querySelector('.cover-caption');
  // let defaultCover = document.querySelector('.cover-img');
  // defaultCover.src = "https://cdn.shopify.com/s/files/1/0661/3761/files/JewelryMain.jpg?v=1618106964";
  // defaultCaption.innerHTML = "About our atelier";
  // document.querySelector('.image-link').href = '/pages/about-us-1';
  // defaultCaption.href = '/pages/about-us-1';

  let defaultJewelry = document.querySelector("#default-jewelry");
  let defaultImg = defaultJewelry.dataset.defaultImg;
  let defaultLink = defaultJewelry.dataset.defaultLink;
  let defaultText = defaultJewelry.dataset.defaultText;

  let jewelryImgCon = document.querySelector("#jewelry-img");
  let jewelryLinkCon = document.querySelector("#jewelry-link-one");
  let jewelryLinkConTwo = document.querySelector("#jewelry-link-two");

  jewelryImgCon.src = defaultImg;
  jewelryLinkCon.href = defaultLink;
  jewelryLinkConTwo.href = defaultLink;
  jewelryLinkConTwo.innerHTML = defaultText;

  let jewelryExpander = document.querySelector("#jewelry-overlay a");
  let campaignsExpander = document.querySelector("#campaigns-overlay a");

  if (jewelryExpander) {
    jewelryExpander.classList.remove("underline");
  }

  if (campaignsExpander) {
    campaignsExpander.classList.remove("underline");
  }

  navOverlay.classList.remove("active");
  document.querySelector("body").classList.remove("no-scroll");
  let filtersCon = document.querySelector("#filters-pop");
  let mobileSplitProduct = document.querySelector(".mobile-module .open-state");
  if (mobileSplitProduct) {
    mobileSplitProduct.classList.remove("active");
  }
  if (filtersCon) {
    filtersCon.classList.remove("open");
  }
};

let headerHover = document.querySelector("#header-hover");
let headerClick = document.querySelector("#header-click");

if (headerHover) {
  let jewelryOverlay = headerHover.querySelector("#jewelry-overlay");
  let campaignsOverlay = headerHover.querySelector("#campaigns-overlay");

  jewelryOverlay.addEventListener("mouseover", function () {
    activateOverlay();
  });

  jewelryOverlay.addEventListener("mouseleave", function () {
    killOverlay();
  });

  campaignsOverlay.addEventListener("mouseover", function () {
    activateOverlay();
  });

  campaignsOverlay.addEventListener("mouseleave", function () {
    killOverlay();
  });
}

if (headerClick) {
  let jewelryExpand = headerClick.querySelector("#jewelry-overlay a");
  let campaignsExpand = headerClick.querySelector("#campaigns-overlay a");

  let headerExpanders = headerClick.querySelectorAll(".activate-overlay");

  // headerExpanders.forEach(function(item){
  //   item.addEventListener('click', function(event){
  //     event.preventDefault();
  //     activateOverlay();
  //   });
  // });

  jewelryExpand.addEventListener("click", function (event) {
    event.preventDefault();

    campaignsExpand.classList.remove("underline");
    this.classList.toggle("underline");

    if (document.querySelector("#shop-dropdown-menu").classList.contains("active")) {
      killOverlay();
      document.querySelector("#shop-dropdown-menu").classList.remove("active");
      console.log("toggle switch");
    } else {
      document.querySelector("#campaigns-dropdown-menu").classList.remove("active");
      document.querySelector("#shop-dropdown-menu").classList.toggle("active");
      activateOverlay();
    }
  });

  campaignsExpand.addEventListener("click", function (event) {
    event.preventDefault();

    jewelryExpand.classList.remove("underline");
    this.classList.toggle("underline");

    if (document.querySelector("#campaigns-dropdown-menu").classList.contains("active")) {
      killOverlay();
      document.querySelector("#campaigns-dropdown-menu").classList.remove("active");
      console.log("toggle switch");
    } else {
      document.querySelector("#shop-dropdown-menu").classList.remove("active");
      document.querySelector("#campaigns-dropdown-menu").classList.toggle("active");
      activateOverlay();
    }
  });

  navOverlay.addEventListener("click", function (event) {
    event.preventDefault();
    document.querySelector("#campaigns-dropdown-menu").classList.remove("active");
    document.querySelector("#shop-dropdown-menu").classList.remove("active");
    killOverlay();
  });
}

navOverlay.addEventListener("click", function () {
  document.querySelector("#close-cart").classList.remove("active");
  cartNav.classList.remove("open");
  document.querySelector("body").classList.remove("no-scroll");
  zHeader.classList.remove("temp-z-index");
  let mobileModule = document.querySelector(".mobile-module");
  if (mobileModule) {
    mobileModule.classList.remove("extend");
  }
  killOverlay();
});

//Dropdown Menu
// let coverImages = document.querySelectorAll('.cover-switch');

// let defaultCover = document.querySelector('.cover-img');
// let defaultImage = defaultCover.src;
// let defaultLink = document.querySelector('.image-link');

// let defaultCaption = document.querySelector('.cover-caption');
// let defaultText = defaultCaption.innerHTML;

// coverImages.forEach(function(item, index){
//   // item.addEventListener('mouseover', function(){
//   //   let switchCover = item.dataset.coverSrc;
//   //   defaultCover.src = switchCover;

//   //   let switchLink = item.dataset.url;
//   //   defaultLink.href = switchLink;

//   //   let switchCaption = item.dataset.caption;
//   //   defaultCaption.href = switchLink;
//   //   defaultCaption.innerHTML = switchCaption;
//   // });

//   // item.addEventListener('mouseleave', function(){
//   //   defaultCover.src = defaultImage;
//   //   defaultCaption.innerHTML = defaultText;
//   // });

// });

//Hover Images
let hoverLinks = document.querySelectorAll(".click-header .hover-img");
let jewelryImgCon = document.querySelector("#jewelry-img");
let jewelryImage = document.querySelector("#jewelry-img").src;
let jewelryLinkCon = document.querySelector("#jewelry-link-one");
let jewelryLinkConTwo = document.querySelector("#jewelry-link-two");
let jewelryLink = document.querySelector("#jewelry-link-one").href;

hoverLinks.forEach(function (item, i) {
  item.addEventListener("mouseover", function () {
    if (item.dataset.img != "") {
      let switchCover = item.dataset.img;
      jewelryImgCon.src = switchCover;

      let switchText = item.dataset.text;
      jewelryLinkConTwo.innerHTML = switchText;

      let switchLink = item.href;
      jewelryLinkCon.href = switchLink;
      jewelryLinkConTwo.href = switchLink;
    }
  });
});

//Open Mobile Nav Menu
let navBtn = document.querySelector("#nav-btn");
let closeBtn = document.querySelector("#close-btn");
let mobileNav = document.querySelector("#mobile-nav");

navBtn.addEventListener("click", function (event) {
  event.preventDefault();
  closeBtn.classList.remove("hide");
  this.classList.add("hide");
  document.querySelector("body").classList.toggle("no-scroll");
  mobileNav.classList.toggle("open");
});

closeBtn.addEventListener("click", function (event) {
  event.preventDefault();
  this.classList.add("hide");
  navBtn.classList.remove("hide");
  document.querySelector("body").classList.toggle("no-scroll");
  mobileNav.classList.toggle("open");
});

//Mobile Side Menu
let jewelryBtn = document.querySelector(".jewelry-btn");
let jewelryMenu = document.querySelector(".jewelry-menu");

let campaignsBtn = document.querySelector(".campaigns-btn");
let campaignsMenu = document.querySelector(".campaigns-menu");

//Mobile Side Menu Functions
jewelryBtn.addEventListener("click", function (event) {
  event.preventDefault();
  this.classList.toggle("highlight");
  jewelryMenu.classList.toggle("active");

  campaignsBtn.classList.remove("highlight");
  campaignsMenu.classList.remove("active");
});

campaignsBtn.addEventListener("click", function (event) {
  event.preventDefault();
  this.classList.toggle("highlight");
  campaignsMenu.classList.toggle("active");

  necklacesMenu.classList.remove("expand");
  earringsMenu.classList.remove("expand");

  jewelryBtn.classList.remove("highlight");
  jewelryMenu.classList.remove("active");
});


const menuConfig = [
  { btnSelector: ".in-stock-btn", menuSelector: ".in-stock-menu" },
  { btnSelector: ".earrings-btn", menuSelector: ".earrings-menu" },
  { btnSelector: ".necklaces-btn", menuSelector: ".necklaces-menu" },
  { btnSelector: ".bracelets-btn", menuSelector: ".bracelets-menu" },
  { btnSelector: ".rings-btn", menuSelector: ".rings-menu" },
];

const toggleMenu = (menuToToggle, allMenus) => {
  menuToToggle.classList.toggle("expand");
  allMenus.forEach((menu) => {
    if (menu !== menuToToggle) {
      menu.classList.remove("expand");
    }
  });
};

menuConfig.forEach(({ btnSelector, menuSelector }) => {
  const btn = document.querySelector(btnSelector);
  const menu = document.querySelector(menuSelector);
  const allMenus = menuConfig.map(({ menuSelector }) => document.querySelector(menuSelector));

  btn.addEventListener("click", (event) => {
    event.preventDefault();
    toggleMenu(menu, allMenus);
  });
});



//Side Cart
let cartBtns = document.querySelectorAll(".cart-btn");
let cartNav = document.querySelector("#side-cart");
let zHeader = document.querySelector("header");

cartBtns.forEach(function (item, i) {
  item.addEventListener("click", function (event) {
    let clkHeadOne = document.querySelector("#campaigns-dropdown-menu");
    //let clkHeadTwo = document.querySelector('#shop-dropdown-menu');

    if (clkHeadOne) {
      document.querySelector("#campaigns-dropdown-menu").classList.remove("active");
      document.querySelector("#shop-dropdown-menu").classList.remove("active");
    }

    activateOverlay();
    event.preventDefault();
    this.classList.toggle("active");
    cartNav.classList.toggle("open");
    zHeader.classList.add("temp-z-index");
    document.querySelector("body").classList.add("no-scroll");
  });
});

let closeCartBtn = document.querySelector("#close-cart");
closeCartBtn.addEventListener("click", function (event) {
  event.preventDefault();
  this.classList.toggle("active");
  cartNav.classList.toggle("open");
  let mobileModule = document.querySelector(".mobile-module");
  if (mobileModule) {
    document.querySelector(".mobile-module").classList.remove("extend");
  }
  zHeader.classList.remove("temp-z-index");
  document.querySelector("body").classList.remove("no-scroll");
  killOverlay();
});

let campaignsHeaderBtn = document.querySelector("#campaigns-header-btn");
campaignsHeaderBtn.addEventListener("click", function (event) {
  event.preventDefault();
});

//Back To Shopping
let backToShoppingBtn = document.querySelector("#mobile-back-to-shopping");
backToShoppingBtn.addEventListener("click", function (event) {
  event.preventDefault();
  this.classList.toggle("active");
  cartNav.classList.toggle("open");
  let mobileModule = document.querySelector(".mobile-module");
  if (mobileModule) {
    document.querySelector(".mobile-module").classList.remove("extend");
  }
  zHeader.classList.remove("temp-z-index");
  document.querySelector("body").classList.remove("no-scroll");
  killOverlay();
});

//Gift Wrapping
let giftWrap = document.querySelector("#product-gift-wrapping");
if (giftWrap) {
  let gwBtns = giftWrap.querySelectorAll(".btn");
  gwBtns.forEach(function (item) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
    });

    item.style.visibility = "hidden";
  });
}

//Newsletter
let newsletterFormWrap = document.querySelectorAll('.newsletter-klaviyo');

if (newsletterFormWrap.length > 0) {
  newsletterFormWrap.forEach(function (item) {
    let newsletterForm = item.querySelector('form');
    let newsletterEmail = item.querySelector('.newsletter-email');
    let successMessage = item.querySelector('.success');
    let errorMessage = item.querySelector('.error');

    newsletterForm.addEventListener('submit', function (event) {
      event.preventDefault();

      const emailValue = newsletterEmail.value.trim();

      // Check if email is empty
      if (!emailValue) {
        errorMessage.classList.remove('hide');
        //errorMessage.textContent = 'Please enter a valid email address.';
        successMessage.classList.add('hide');
        return;
      }

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: emailValue,
                  properties: {
                    "website-source": "newsletter-popup"
                  }
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "WiQXqX",
              },
            },
          },
        },
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          'content-type': 'application/vnd.api+json',
          revision: '2024-10-15',
        },
        body: JSON.stringify(payload),
      };

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=TJ76UH', requestOptions)
        .then((res) => {
          if (res.ok) {
            return res.text().then((text) => (text ? JSON.parse(text) : {}));
          } else {
            return res.json().then((errorDetails) => {
              throw new Error(`Failed to subscribe: ${errorDetails.message}`);
            });
          }
        })
        .then((res) => {
          console.log('Submission successful:', res);
          newsletterForm.classList.add('hide');
          successMessage.classList.remove('hide');
          errorMessage.classList.add('hide');
        })
        .catch((err) => {
          console.error('Error occurred:', err);
          errorMessage.classList.remove('hide');
          //errorMessage.textContent = 'Something went wrong. Please try again.';
          successMessage.classList.add('hide');
        });
    });
  });
}
